import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import CircleIcon from "../../../CircleIcon/CircleIcon";
import { InquiryToCustomerHistoryLog } from "../../../../types/HistoryLog";
import { getCreatedBy } from "../../../../services/backofficeUserService";
import { useBackofficeUser } from "../../../../provider/BackofficeUserProvider";
import { QuestionAnswerOutlined, UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { InquiryToCustomer } from "../../../../types/InquiryToCustomer";
import { translate } from "../../../../services/Translations/translatorService";
import dayjs from "dayjs";

type CaseHistoryInquiryToCustomerProps = {
  historyLog: InquiryToCustomerHistoryLog;
  type?: string;
};

export default function CaseHistoryInquiryToCustomer({ historyLog }: CaseHistoryInquiryToCustomerProps) {
  const { backofficeUsers } = useBackofficeUser();
  const inquiryToCustomer: InquiryToCustomer = historyLog.logData.inquiryToCustomer!;
  const logDate = dayjs(historyLog.logDate);
  const [isExpanded, setIsExpanded] = useState(false);

  const getInquiryTypeText = (
    inquiryType: "documents" | "appointment" | "information" | "informationAndDocuments" | "decision" | "link"
  ) => {
    switch (inquiryType) {
      case "documents":
        return "Anfrage für Dokumente";
      case "appointment":
        return "Anfrage für Termin";
      case "information":
        return "Anfrage für Informationen";
      case "informationAndDocuments":
        return "Anfrage für Informationen und Dokumente";
      case "decision":
        return "Anfrage für Entscheidung";
      case "link":
        const identifier = inquiryToCustomer?.identifier ? inquiryToCustomer.identifier : "unknown";

        return translate(`historyItem.inquiry.link.identifier.${identifier}.label`);
    }
  };
  const getDoneText = () => {
    if (inquiryToCustomer.inquiryType === "appointment") {
      if (inquiryToCustomer.doneBy === "system") {
        return "Angefragter Termin erfolgreich stattgefunden";
      }
      if (inquiryToCustomer.doneBy === "customer") {
        return "Abgelehnt durch Mandantschaft";
      }
      return getCreatedBy(inquiryToCustomer.doneBy, backofficeUsers);
    }

    if (inquiryToCustomer.doneBy === "customer") {
      return "Beantwortung durch Mandantschaft über Servicewelt";
    }
    return getCreatedBy(inquiryToCustomer.doneBy, backofficeUsers);
  };
  const textOrMinusIfEmpty = (text: string | null) => (!!text ? text : "-");
  const getInformationText = () => {
    let informationText = "";
    if (inquiryToCustomer.inquiryType === "appointment") {
      informationText += `Hintergrund für Gespräch: ${textOrMinusIfEmpty(
        inquiryToCustomer.inquiryTextAppointment
      )}\n\n`;
      informationText += `Begründung zur Ablehnung: ${textOrMinusIfEmpty(
        inquiryToCustomer.inquiryTextAppointmentCustomer
      )}`;
    }

    if (inquiryToCustomer.inquiryType === "decision") {
      let answer = translate(`historyItem.inquiry.decision.answer.${inquiryToCustomer.inquiryDecisionAnswer}.label`);

      informationText += `<p><strong>Frage:</strong> ${textOrMinusIfEmpty(
        inquiryToCustomer.inquiryDecisionQuestion
      )}</p>`;
      informationText += `<p><strong>Antwort Mandantschaft:</strong> ${textOrMinusIfEmpty(answer)}</p>`;
    }
    if (["information", "informationAndDocuments"].includes(inquiryToCustomer.inquiryType)) {
      informationText += `Benötigte Informationen: ${textOrMinusIfEmpty(inquiryToCustomer.inquiryTextInformation)}\n\n`;
      informationText += `Antwort Mandantschaft: ${textOrMinusIfEmpty(
        inquiryToCustomer.inquiryTextInformationCustomer
      )}\n\n`;
    }
    if (["documents", "informationAndDocuments"].includes(inquiryToCustomer.inquiryType)) {
      informationText += `Benötigte Dokumente: ${inquiryToCustomer.requestedDocuments
        .map((document: any) => document.documentName)
        .join(", ")}\n\n`;
      informationText += `Erklärung zu Dokumenten: ${textOrMinusIfEmpty(inquiryToCustomer.inquiryTextDocuments)}\n\n`;
      informationText += `Anmerkungen und Fragen Mandantschaft: ${textOrMinusIfEmpty(
        inquiryToCustomer.inquiryTextDocumentsCustomer
      )}\n`;
    }
    return informationText;
  };
  return (
    <>
      <Grid container>
        <Grid
          size={{
            xs: 2,
            md: 1
          }}>
          <CircleIcon icon={<QuestionAnswerOutlined />} type={"muiIcon"} />
        </Grid>
        <Grid
          size={{
            xs: 8,
            md: 10
          }}>
          <Box
            sx={{
              fontSize: "1rem",
              textDecoration: "line-through",
            }}
          >
            {getInquiryTypeText(inquiryToCustomer.inquiryType)} gestellt{" "}
            {dayjs(inquiryToCustomer.created).format("DD.MM.YYYY HH:mm")} |{" "}
            {getCreatedBy(inquiryToCustomer.createdBy, backofficeUsers)}
          </Box>
          <Grid>
            Erledigt: {logDate.format("DD.MM.YYYY HH:mm")} | {getDoneText()}
          </Grid>
          {isExpanded && (
            <Box sx={{ fontSize: "1rem", paddingTop: 1 }} dangerouslySetInnerHTML={{ __html: getInformationText() }} />
          )}
        </Grid>
        <Grid
          size={{
            xs: 2,
            md: 1
          }}>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <UnfoldLess /> : <UnfoldMore />}
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}
